import {action, observable} from 'mobx';

import { api } from '../services';
import {QsHelper} from "../helpers";

class RouteTaskStore {
  @observable loading = false;
  @observable error = undefined;
  @observable routeTasks = [];
  @observable routeTasksTotal;
  @observable filtersCollection = {};
  @observable hasNoTaskYet = true;


  @action
  load(page=1, size=10) {

    const qs = new QsHelper(window.location.search),
      filters = qs.serializeObject({ ...this.filtersCollection });

    this.loading = true;
    return api('getRoutesTask',{ filters, page, size }).then(routeTasks => {

      this.routeTasks = routeTasks.rows;
      this.routeTasksTotal = routeTasks.count;
      if(routeTasks.count !== 0) {
        this.hasNoTaskYet = false;
      }
    })
      .catch( err => {
      this.error = err;
    })
      .finally(() => {
        this.loading = false;
      })
  }

  @action
  assign(taskId, body) {
    this.loading = true;
    return api('assignRoutesTask', taskId, body)
      .then(() => {
        this.load();
      })
      .catch( err => {
        this.error = err;
      })
      .finally(() => {
        this.loading = false;
      })
  }

  @action
  unAssign(taskId) {
    this.loading = true;
    return api('unassignRoutesTask', taskId)
      .then(() => {
        this.load();
      })
      .catch( err => {
        this.error = err;
      })
      .finally(() => {
        this.loading = false;
      })
  }

  @action
  create(name, position, date, note, positionDetails) {
    this.loading = true;
    return api('createRoutesTask', name, position, date, note, positionDetails)
      .then(() => {
        this.load();
      })
      .catch( err => {
        this.error = err;
      })
      .finally(() => {
        this.loading = false;
      })
  }

  @action
  edit(id, name, position, date, note, positionDetails) {
    this.loading = true;
    return api('editRoutesTask', id, name, position, date, note, positionDetails)
      .then(() => {
        this.load();
      })
      .catch( err => {
        this.error = err;
      })
      .finally(() => {
        this.loading = false;
      })
  }

  @action
  delete(id) {

    this.loading = true;

    api('deleteRoutesTask', id)
      .then(() => {

        this.load();
      })
      .catch( err => {

        this.error = err;
      })
      .finally(() => {

        this.loading = false;
      })
  }

  @action
  setFilter = (filter, value) => {
    this.filtersCollection[filter] = value.toString();
    this.load();
  }

  @action
  resetFilters = () => {
    this.filtersCollection = {};
  }
}

export default new RouteTaskStore();



// WEBPACK FOOTER //
// ./src/stores/routeTaskStore.js